/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgGenericCoverage32(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={32}
      height={32}
      fill='none'
      viewBox='0 0 32 32'
      {...props}
    >
      <path
        stroke='currentColor'
        strokeLinecap='square'
        strokeMiterlimit={5}
        strokeWidth={1.5}
        d='M16 22.5a6 6 0 100-12 6 6 0 000 12z'
      />
      <path
        stroke='currentColor'
        strokeLinecap='square'
        strokeMiterlimit={2}
        strokeWidth={1.5}
        d='M16.25 30.5c-1.232-.663-3.13-1.827-5.341-3.226a13.956 13.956 0 01-6.654-11.893C4.25 11.672 4.25 8 4.25 8l1.168-.073a14.766 14.766 0 008.889-3.7L16.25 2.5l1.944 1.727a14.766 14.766 0 008.889 3.7L28.25 8v7.306c0 4.812-2.479 9.285-6.559 11.836C18.7 29.003 16.25 30.5 16.25 30.5z'
      />
    </svg>
  );
}

export default SvgGenericCoverage32;
